exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".centered-input[data-v-fdadf514] input{text-align:center;font-size:1.4em}.v-calendar[data-v-fdadf514] .v-calendar-daily_head-weekday{display:none!important}.v-tooltip__content[data-v-fdadf514]{border:1px solid #000!important;background:transparent;padding:0}@media print{.v-tooltip[data-v-fdadf514]{display:none}}", ""]);

// exports
